/** @format */

export function setReady(stage) {
  // Use functional setState to ensure state is always up-to-date
  this.setState((prevState) => ({
    ...prevState,
    ready: [...prevState.ready, stage],
  }));
}

export function getReady(stage = "all") {
  return this.state.ready.includes(stage);
}
